import {useEffect, useState} from 'react';

export const SizerCallback = ({width, height, onResize}) => {
  const [w, setWidth] = useState(width);
  const [h, setHeight] = useState(height);

  useEffect(() => {
    if (width !== w || height !== h) {
      onResize();
      setWidth(width);
      setHeight(height);
    }
  }, [width, height, onResize, w, h]);

  return false;
};
